/* [04] Kiosk, V6 sync | 23 OCT 2026
   Restyles the add-to-order button as [Label +] ... price, and adds
   morse marks above each size, matching the V6 product page. */
(function(){
  var M={A:'.-',B:'-...',C:'-.-.',D:'-..',E:'.',F:'..-.',G:'--.',H:'....',I:'..',J:'.---',K:'-.-',L:'.-..',M:'--',N:'-.',O:'---',P:'.--.',Q:'--.-',R:'.-.',S:'...',T:'-',U:'..-',V:'...-',W:'.--',X:'-..-',Y:'-.--',Z:'--..','0':'-----','1':'.----','2':'..---','3':'...--','4':'....-','5':'.....','6':'-....','7':'--...','8':'---..','9':'----.'};
  function morse(txt){
    var out='';
    String(txt||'').toUpperCase().replace(/[^A-Z0-9]/g,'').split('').forEach(function(ch,i){
      if(i) out+='<i class="g"></i>';
      (M[ch]||'').split('').forEach(function(s){out+='<i class="'+(s==='.'?'d':'l')+'"></i>';});
    });
    return out;
  }
  function sizes(){
    document.querySelectorAll('#shBody .size').forEach(function(b){
      if(b.querySelector('.k6-morse')) return;
      var lab=b.querySelector('b'); if(!lab) return;
      var m=document.createElement('span'); m.className='k6-morse'; m.setAttribute('aria-hidden','true');
      m.innerHTML=morse(lab.textContent); b.insertBefore(m,b.firstChild);
    });
  }
  var busy=false;
  function add(){
    var a=document.getElementById('addBtn'); if(!a||busy) return;
    a.classList.add('k6-add');
    if(a.querySelector('.k6-l')) return;
    var p=a.querySelector('.num');
    if(!p){a.classList.remove('k6-split');return;}
    var label=a.textContent.replace(p.textContent,'').replace(/[·\s]+$/,'').trim();
    busy=true;
    a.innerHTML='<span class="k6-l">'+label.replace(/</g,'&lt;')+' <i class="k6-plus" aria-hidden="true">+</i></span><span class="num k6-p">'+p.textContent+'</span>';
    a.classList.add('k6-split');
    busy=false;
  }
  function run(){sizes();add();}
  var foot=document.getElementById('shFoot'), body=document.getElementById('shBody');
  var mo=new MutationObserver(run);
  if(foot) mo.observe(foot,{childList:true,subtree:true,characterData:true});
  if(body) mo.observe(body,{childList:true,subtree:true});
  run();
})();
